<template>
    <v-container fluid class="pa-0">
        <hr-clock-device-helper v-if="device" :device="device" class="ma-4 mb-0"></hr-clock-device-helper>
        <edit modelDef="hrclockdevices" :id="id"></edit>
    </v-container>
</template>

<script>
import Edit from '@/components/common/Edit'
import HrClockDeviceHelper from './HrClockDeviceHelper'

export default {
    name: 'hr-clock-device-edit',
    components: { Edit, HrClockDeviceHelper },
    props: { id: Number },

    data() {
        return { device: null }
    },

    methods: {
        load() {
            if (!this.id) return
            this.axios.get(`hrclockdevices/${this.id}?lite=1`).then(r => {
                this.device = r.data.model || r.data
            })
        },
    },

    created() {
        this.load()
    },

    watch: {
        id() { this.load() },
    },
}
</script>
